
import appConfig from '../config/appConfig.js';

const url = appConfig.ApiUrl || "";
export default {
	BaseUrl: url,
	ForgotPassword: url + '/Controllers/LoginController.ashx?action=recoverpassword',
	Login: url + '/Controllers/LoginController.ashx',
	LoginPage: url + 'Login.aspx',
	User: url + '/Controllers/User.ashx',
	UserProfile: url + '/Controllers/UserProfile.ashx',
	EquipmentList: url + '/Controllers/Equipment.ashx',
	CycleList: url + '/Controllers/Cycle.ashx',
	LocationForm: url + '/Controllers/Location.ashx',
	EquipmentType: url + '/Controllers/EquipmentType.ashx',
	AccessLogDetailList: url + '/Controllers/AccessLogDetail.ashx',
	GridPreferenceManager: url + '/Controllers/GridPreferenceManager.ashx',
	AppConfig: url + '/Controllers/AppConfig.ashx',
	Client: url + '/Controllers/Client.ashx',
	GetCycleChart: url + '/Controllers/Equipment.ashx?action=otherAction&otherAction=GetCycleChart',
	GenerateLicense: url + '/GenerateLicense.aspx',
	PTXImage: url + "/FileServer",
	LookupType: url + '/Controllers/LookupType.ashx',
	Lookup: url + '/Controllers/Lookup.ashx',
	SyncAuthorization: url + '/Controllers/SyncAuthorization.ashx',
	Model: url + '/Controllers/Model.ashx',
	LotDetail: url + '/Controllers/LotDetail.ashx',
	Vendor: url + '/Controllers/Vendor.ashx',
	Indicator: url + '/Controllers/Indicator.ashx',
	IncubatorCycle: url + '/Controllers/IncubatorCycle.ashx',
	TaskList: url + '/Controllers/Task.ashx',
	TaskAssignmentList: url + '/Controllers/TaskAssignment.ashx',
	Combo: url + '/Controllers/Combo.ashx',
	TaskTypeList: url + '/Controllers/TaskType.ashx',
	CycleAttachment: url + '/Controllers/CycleAttachment.ashx',
	Attachment: url + '/Controllers/Attachment.ashx',
	DownloadAttachment: url + '/Controllers/DownloadAttachment.ashx',
	Help: url + '/Controllers/Help.ashx',
	BIHistoryReport: url + '/Controllers/BIHistoryReport.ashx',
	CycleUsageReport: url + '/Controllers/CycleUsageReport.ashx',
	EquipmentUsesReport: url + '/Controllers/EquipmentUsesReport.ashx',
	Role: url + '/Controllers/SecurityRole.ashx',
	RoleModuleTabel: url + '/Controllers/RoleModule.ashx',
	ReusableTestPack: url + '/Controllers/ReusableTestPack.ashx',
	HolidayList: url + '/Controllers/Holiday.ashx',
	SterilizerCycleList: url + '/Controllers/SterilizerCycle.ashx',
	IncubatorCycleDetail: url + '/Controllers/IncubatorCycleDetail.ashx',
	TaskHistoryReport: url + '/Controllers/TaskHistoryReport.ashx',
	PreviewDocument: url + '/Controllers/PreviewDocument.ashx',
	HelpVideo: url + '/Controllers/HelpVideo.ashx',
	PrintConfig: url + '/Controllers/PrintConfig.ashx',
	EndoSystemCycleList: url + '/Controllers/EndoSystemCycle.ashx',
	LanguageDetail: url + '/Controllers/LanguageDetail.ashx',
	Language: url + '/Controllers/Language.ashx',
	EndoScopeList: url + '/Controllers/EndoScope.ashx',
	EndoScopeCodeList: url + '/Controllers/EndoScopeCode.ashx',
	UserType: url + '/Controllers/UserType.ashx',
	TransactionList: url + '/Controllers/TransactionInfo.ashx',
	CabinetLogList: url + '/Controllers/EndoScope.ashx',
	ClientRequests: url + '/Controllers/ClientRequests.ashx',
	AdvantageCycleList: url + '/Controllers/AdvantageCycle.ashx',
	TopicPermission: url + '/Controllers/TopicPermission.ashx',
	Users: url + '/Controllers/Users.ashx',
	Logs: url + '/Controllers/Logs.ashx',
	Hospital: url + '/Controllers/Client.ashx',
	Items: url + '/Controllers/Items.ashx',
	BrokerTransaction: url + '/Controllers/BrokerTransaction.ashx',
	Command: url + '/Controllers/Command.ashx',
	Config: url + '/Controllers/Config.ashx',
	SmtpTest: url + '/Controllers/SmtpTest.ashx',
	Assets: url + '/Controllers/Assets.ashx',
	Antenna: url + '/Controllers/Antenna.ashx',
	AssetsCode: url + '/Controllers/AssetCode.ashx',
	TagActivity: url + '/Controllers/TagActivity.ashx',
	TopicPermissionLookup: url + '/Controllers/TopicPermissionLookup.ashx',
	ItemSync: url + '/Controllers/ItemSync.ashx',
	UserSync: url + '/Controllers/UserSync.ashx',
	EndoSetupScope: url + '/Controllers/EndoSetupScope.ashx',
	EndoSetupHookup: url + '/Controllers/EndoSetupHookup.ashx',
	EndoSetupParameter: url + '/Controllers/EndoSetupParameter.ashx',
	EndoSetupEquipment: url + '/Controllers/EndoSetupEquipment.ashx',
	HuluInterfaceConfig: url + '/Controllers/HuluInterfaceConfig.ashx',
	HuluRegion: url + '/Controllers/HuluRegion.ashx',
	HuluMachineConfig: url + '/Controllers/HuluMachineConfig.ashx',
	HuluScope: url + '/Controllers/HuluScope.ashx',
	ScopeRegionConfiguration: url + '/Controllers/ScopeRegionConfiguration.ashx',
	HuluScopeRegion: url + '/Controllers/HuluScopeRegion.ashx',
	UploadDiagnosticsInfo: url + '/Controllers/Config.ashx',
	UploadCycleFiles: url + '/Controllers/Config.ashx',
	EndoUserTypeLookup: url + '/Controllers/EndoUserType.ashx',
	HuluInterfaceLogs: url + '/Controllers/HuluInterfaceLogs.ashx',
	TrackCycleFile: url + '/Controllers/TrackCycleFile.ashx',
	ViewAttachment: url + '/Controllers/ViewAttachment.ashx',
	ViewerLog: url + '/Controllers/logError',
	EndoProfile: url + '/Controllers/EndoProfile.ashx',
	EndoSetupPhysician: url + '/Controllers/EndoSetupPhysician.ashx',
	EndoSetupUser: url + '/Controllers/EndoSetupUser.ashx',
	EndoCycles: url + '/Controllers/EndoCycles.ashx',
	AuthorizedClients: url + '/Controllers/AuthorizedClients.ashx',
	Statistics: url + '/Controllers/Statistics.ashx',
	Nonmedivator: url + '/Controllers/Nonmedivator.ashx',
	DashBoardEqupmentType: url + '/Controllers/DashBoardEquipmentType.ashx',
	DashBoardEquipment: url + '/Controllers/DashBoardEquipment.ashx',
	EquipmentReport: url + '/Controllers/EquipmentReport.ashx',
	Thumbnail: url + "/thumbnail/",
	UploadPackageFile: url + '/Controllers/Config.ashx',
	DepartmentLookup: url + "/Controllers/DepartmentLookup.ashx",
	HuluScopeEndpoint: url + "/Controllers/HuluScope.ashx",
	EndoSetupHookupRapidAER: url + '/Controllers/EndoSetupHookupRapidAER.ashx',
	UserPassword: url + '/Controllers/UserPassword.ashx'
};
